<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Stock Transfer
            <v-icon right>add_circle</v-icon>
          </v-btn>
          <v-btn color="primary" @click="openDialog=true">Import Stock transfer</v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker v-model="fromDate" @change="assignFromDateToQueryParam"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker v-model="toDate" @change="assignToDateToQueryParam"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="stockTransferStatusList"
                label="Choose Stock Transfer Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.fromWarehouseId"
                :items="warehouseList"
                color="blue-grey lighten-2"
                :hide-no-data="true"
                label="Choose From Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose To Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.toWarehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12>
        <v-card>
          <v-card-text class="font-weight-bold">
            <div>
              <v-btn
                :loading="printAllButtonLoading"
                color="primary"
                @click="printAllStockTransfer('printStockTransfer')"
              >PRINT ALL</v-btn>
              <v-btn
                :loading="printAllButtonLoading"
                color="success"
                @click="exportAllStockTransfer()"
              >EXPORT ALL</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockTransferList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.issueDateInMilliSeconds | format-ms-date }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.fromWarehouseName }}</td>
              <td>{{ props.item.toWarehouseName }}</td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <stockTransferExcel :isOpen="openDialog" v-on:change="dialogClose()"></stockTransferExcel>
    <!-- print section -->
    <div id="printStockTransfer" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Stock Transfer Report</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <span v-for="(item, index) in allStockTransferList" :key="index">
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left">Issue Date</th>
                <th style="text-align:left">Issue No</th>
                <th style="text-align:left">From Warehouse</th>
                <th style="text-align:left">To Warehouse</th>
                <th style="text-align:left">Stock Transfer Status</th>
                <th style="text-align:left">Description</th>
                <th style="text-align:left">Updated Date</th>
                <th style="text-align:left">Updated By</th>
              </tr>
            </thead>
            <tbody>
              <tr style="border-bottom:1px solid black;">
                <td>{{ item.issueDateInMilliSeconds | format-ms-date}}</td>
                <td>{{ item.issueNo }}</td>
                <td>{{ item.fromWarehouseName}}</td>
                <td>{{ item.toWarehouseName}}</td>
                <td>{{ item.status }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ item.updatedBy }}</td>
              </tr>
              <tr style="border-bottom:1px solid black;">
                <th style="text-align:left;">Stock Transfer Items</th>
                <td colspan="4">
                  <table
                    style="font-family: arial, sans-serif;width: 100%;font-size:11px;border:1px solid black"
                  >
                    <thead style="border-bottom:1px solid black;border-top:1px solid black">
                      <tr>
                        <th style="text-align:left">Code</th>
                        <th style="text-align:left">Product Name</th>
                        <th style="text-align:left">Unit</th>
                        <th style="text-align:left">Qty</th>
                        <th style="text-align:left">Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detailItem, index) in item.stockTransferItems" :key="index">
                        <td style="text-align:left">{{detailItem.productCode}}</td>
                        <td style="text-align:left">{{detailItem.productName}}</td>
                        <td style="text-align:left">{{detailItem.factorUnitName}}</td>
                        <td style="text-align:left">{{detailItem.qty}}</td>
                        <td style="text-align:left">{{detailItem.remark}}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style="height: 10px;">
                <td colspan="5"></td>
              </tr>
            </tbody>
          </span>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { stockTransferService } from "../../services/stock-transfer-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import stockTransferExcel from "../../components/stock-transfer/StockTransferExcel";

export default {
  name: "StockTransferList",

  components: { stockTransferExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),

    fromDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    toDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Stock Transfer",
        disabled: true
      }
    ],
    headers: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "From Warehouse", value: "fromWarehouse.name" },
      { text: "To Warehouse", value: "toWarehouse.name" },
      { text: "Stock Transfer Status", value: "status" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0
    },
    stockTransferStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "DELIVERY", value: "DELIVERY" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    stockTransferList: [],
    allStockTransferList: [],
    warehouseList: [],
    printAllButtonLoading: false,
    openDialog: false,
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueDate: "",
      issueNo: "",
      status: "",
      fromWarehouseId: "",
      toWarehouseId: ""
    }
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockTransferList();
      },
      deep: true
    }
  },
  created() {
    if (this.user.role.roleName == "WAREHOUSE_MANAGER") {
      this.queryParams.fromWarehouseId = this.user.warehouseId;
    }
    //for deep linking
    if (this.$route.query.fromWarehouseId) {
      this.queryParams.fromWarehouseId = this.$route.query.fromWarehouseId;
    }
    if (this.$route.query.toWarehouseId) {
      this.queryParams.toWarehouseId = this.$route.query.toWarehouseId;
    }
    if (this.$route.query.issueDate) {
      this.queryParams.issueDate = this.$route.query.issueDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getWarehouseList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-transfers",
        query: this.queryParams
      });
      this.getStockTransferList();
    },
    getStockTransferList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockTransferService
        .getStockTransferList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockTransferList = res.data.stockTransferList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
        });
    },

    onRegister() {
      this.$router.push("/stock-transfer/new");
    },
    dialogClose() {
      this.openDialog = false;
      this.getStockTransferList();
    },
    onEdit(stockTransfer) {
      // go to details page
      this.$router.push("/stock-transfer/" + stockTransfer.id);
    },
    assignFromDateToQueryParam() {
      this.queryParams.fromDate = this.fromDate;
    },
    assignToDateToQueryParam() {
      this.queryParams.toDate = this.toDate;
    },
    printAllStockTransfer(divName) {
      this.printAllButtonLoading = true;
      stockTransferService
        .getAllStockTransferList(this.queryParams)
        .then(res => {
          if (res.data) {
            this.allStockTransferList = res.data.stockTransferList;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    exportAllStockTransfer() {
      this.printAllButtonLoading = true;
      stockTransferService
        .exportAllStockTransferExcel(this.queryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    }
  }
};
</script>